import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import User, { newUser } from "../../models/user";
import UserChangePasswordForm from "./UserChangePasswordForm";

interface UserUpdateModalProps {
  show: boolean;
  user?: User;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const UserChangePasswordModal: React.FC<UserUpdateModalProps> = ({
  show,
  user,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialUser, setInitialUser] = useState<User>(user ? user : newUser());

  const modalTitle = user
    ? `Cambiar contraseña de usuario: ${user.email}`
    : "Cambiar contraseña";

  const onClose = () => {
    setInitialErrors({});
    setInitialUser(newUser());
    onCancel();
  };

  useEffect(() => {
    setInitialUser(user ? user : newUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <UserChangePasswordForm
            initialUser={initialUser}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default UserChangePasswordModal;
